import { useSelector } from "@xstate/react"
import useRootMachineStore from "../../stores/useRootMachineStore";

// Accept either a string or an array path
const normalizePath = (p) => (Array.isArray(p) ? p : [p]);

export const useRootMachine = () => (useRootMachineStore((s) => s.rootMachine));

export const useRootMachineState = (selector) => {
  const rootMachine = useRootMachine();
  return useSelector(rootMachine, selector);
};

export const useChildMachine = (childId) => {
  const rootMachine = useRootMachine();
  return useSelector(rootMachine, (state) => state.children[childId]);
};

export const useChildMachineState = (childId, selector) => {
  const machine = useChildMachine(childId);
  return useSelector(machine, selector);
};

export const useNestedChildMachine = (childPath) => {
  const rootActor = useRootMachine();
  const path = normalizePath(childPath);

  // We pass the root actorRef to useSelector so we subscribe to it
  // Inside the selector the provided path is walked until the desired child is reached
  return useSelector(rootActor, () => {
      let actor = rootActor; // Initial actor

      for (const id of path) {
        if (!actor) return null;

        actor =
          actor.children?.[id] ?? // Try to access actor.children
          actor.getSnapshot?.()?.children?.[id] ?? // Try to get the childern from the snapshot of the actor
          null; // Fallback to null, no child found
      }
      
      return actor ?? null;
  });
};

export const useNestedChildMachineState = (childPath, selector) => {
  const machine = useNestedChildMachine(childPath);
  return useSelector(machine, selector);
};